import React, { useState, useEffect } from "react";
import { getCookie } from "../../utils/cookies";
import axios from "axios";

export interface DataCardProps {
  title: string;
  color: string;
  endpoint: string;
  path?: string;
  icon: JSX.Element; // => React Component
  details?: string; // => React Component
  description?: string;
}

export default function DataCard(p: DataCardProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      const JWT = await getCookie("ea1-auth");
      const { data } = await axios(p.endpoint, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: JWT,
        },
      });
      console.log(data);
      setData(data);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.log("error fetching data");
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className='d-flex flex-column justify-content-center align-items-center'
      id='basicLoader'
      style={{
        backgroundColor: "#F4F4F4",
        border: "1px solid rgba(0, 0, 0, 0.12)",
        borderRadius: ".6em",
        boxShadow: "rgba(0, 0, 0, 0.08) 0px 4px 12px",
        minHeight: "18em",
        maxHeight: "18em",
        minWidth: 175,
        padding: "4%",
      }}
    >
      <div
        className='d-flex justify-content-center align-items-center'
        style={{
          borderRadius: "50%",
          height: "2.5em",
          width: "2.5em",
          backgroundColor: "rgba(0, 0, 0, 0.06)",
          margin: "7%",
        }}
      >
        <span className={`text-${p.color}`}>{p.icon}</span>
      </div>
      {isLoading ? (
        <div className=''>
          <div
            style={{ width: "50px", height: "50px" }}
            className={`spinner-border text-${p.color}`}
          ></div>
        </div>
      ) : (
        <div
          className='d-flex justify-content-center align-items-center'
          style={{
            marginBottom: "2%",
          }}
        >
          <h1 className={`text-${p.color}`}>{data.length}</h1>
        </div>
      )}
      <div
        style={{
          marginBottom: ".33%",
        }}
      >
        <p
          style={{ fontSize: ".9em", fontWeight: "600" }}
          className='text-center'
        >
          {p.title}
        </p>
      </div>

      <div
        style={{
          marginBottom: "1%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <p style={{ fontSize: "12px", textAlign: "center" }}>
          <a
            href={p.path}
            style={{
              textDecoration: "none",
              color: "red",
              fontSize: "12px",
            }}
          >
            {p.details}
          </a>{" "}
          {p.description}
        </p>
      </div>
    </div>
  );
}
